export default {
	reviewDocuments: {
		account: '@:component.accounts.name',
		balance: 'Saldo',
		status_options: 'Statusoptionen',
		record_count_determined: 'Anzahl an Datensätzen wird ermittelt',
		document_review_protocol: 'Protokoll der Belegprüfung',
		automatic_reminder: 'Automatische Erinnerung',
		edit_documents: 'Dokumente bearbeiten',
		edit_reviewer: 'Prüfer bearbeiten',
		deactivate: 'Deaktivieren',
		activate: 'Aktivieren',
		create_protocol: 'Protokoll erstellen',
		review_requires_reviewer:
			'Es müssen erst Prüfer definiert werden, bevor die Belegprüfung aktiviert werden kann.',
		confirm_disable_review:
			'Möchten Sie die Belegprüfung wirklich deaktivieren?',
		confirm_finish_review_without_checks:
			'Sie haben noch keine Buchung geprüft, sind Sie sicher dass Sie die Belegprüfung abschliessen wollen?',
		confirm_approve_with_disputes:
			'Sie geben diese Belegprüfung frei, haben aber mindestens einer Buchung widersprochen. Sind Sie sicher?',
		confirm_reject_without_disputes:
			'Sie beanstanden diese Belegprüfung, haben aber keiner Buchung widersprochen. Sind Sie sicher?',
		confirm_review_action:
			'Sind Sie sich sicher, dass Sie die Belegprüfung {action} möchten?',
		reopen_notify_reviewers_info:
			'Wenn Sie die Belegprüfung erneut freigeben, können die Prüfer mit ausstehendem Status per E-Mail benachrichtigt werden.',
		notify_pending_reviewers:
			'Prüfer mit ausstehendem Status per E-Mail benachrichtigen',
		confirm_no_changes_after_completion:
			'Nach Abschluss der Belegprüfung sind keine Änderungen mehr möglich, möchten Sie fortfahren?',
		data_updated: 'Daten wurden aktualisiert',
		confirm_enable_review_message:
			'Möchten Sie die Belegprüfung wirklich aktivieren? An die definierten Prüfer wird eine Benachrichtigung verschickt. Nachträgliche Änderungen sind während der Prüfung nicht möglich.',
		review_completed: 'Belegprüfung abgeschlossen',
		invoice_review_completed:
			'Die Belegprüfung ist abgeschlossen, hier können Sie das Protokoll einsehen. Änderungen sind nicht mehr möglich.',
		invoice_review_completed_2:
			'Die Belegprüfung ist bereits abgeschlossen, Änderungen sind nicht mehr möglich.',
		invoice_protocol: 'Belegprüfung Protokoll',
		performedOn: 'Die Belegprüfung wurde am',
		filter: {
			incomplete: 'nicht abgeschlossen',
			all: 'alle',
		},
	},
}
